import { Injectable } from '@angular/core';
import { HorizontalListData, HorizontalListFactory } from 'common';
import { FinancialInstitution } from '../bank-account.model';

@Injectable()
export class BankWidgetAdapter {
  adaptListData = (data: FinancialInstitution): HorizontalListData[] => {
    const messages = data.customerMessages?.map((m) => m.trim())?.filter((m) => m.length > 0) || [];
    const messageItems = messages.map((messasge) => {
      return HorizontalListFactory.createInfoStringItem({
        displayedValue: messasge,
      });
    });
    return [
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'Link status',
        customTemplateName: 'linkStatusValue',
      }),
      ...messageItems
    ];
  };
}
